import React from "react";
import { Horizontal } from "./social-share";

export function HorizontalGrey(props) {
  return <Horizontal grey {...props} />;
}
